import React from 'react';
import styled from 'styled-components';

export const StyledText = styled.div`
  margin-bottom: 16px;
  font-size: 17px;
  line-height: 1.66;
  letter-spacing: 0.5px;
  color: rgba(0, 0, 0, 0.6);
`;

const Text = ({ children }) => {
  return (
    <StyledText>
      {children}
    </StyledText>
  );
};

export default Text;



// WEBPACK FOOTER //
// ./src/components/IterioApp/Warehouses/Text.jsx